<script>
export default {
  name: 'ModalTree',
  props: {
    value: {
      type: Boolean
    },
    tree: {
      type: Array,
      required: true,
      default: () => ([])
    }
  },
  data() {
    return {
      localValue: this.value,
      localTree: this.tree
    };
  },
  methods: {
    open(component) {
      this.localTree.push(component);
    },
    click(key) {
      this.localTree = this.localTree.slice(0, key + 1);
    },
    hide() {
      this.localValue = false;
      this.localTree = [];

      this.$emit('input', false);
    }
  },
  watch: {
    value(v) {
      this.localValue = v;
    },
    tree(v) {
      this.localTree = v;
    }
  }
}
</script>

<template>
  <b-modal v-model="localValue" centered hide-footer size="xl" title-class="font-18" @hide="hide">
    <template #modal-header="{ close }">
      <h5>
        <template v-for="(component, k) of localTree">
          <span :key="k">
            <span @click="click(k)" class="hover-cursor-pointer">{{ component.title }}</span>
            <i v-if="localTree.length - (k + 1)" class="bx bx-right-arrow-alt"></i>
          </span>
        </template>
      </h5>
      <b-button size="sm" @click="close()">
        <i class="bx bx-x font-size-24"></i>
      </b-button>
    </template>

    <template v-for="(component, k) of localTree">
      <component v-show="!(localTree.length - (k + 1))" :is="component.component" v-bind="component.props" :key="k"
                 @open="open"></component>
    </template>
  </b-modal>
</template>